import { render } from "./MatchEventView.vue?vue&type=template&id=43567ecf&scoped=true"
import script from "./MatchEventView.vue?vue&type=script&lang=js"
export * from "./MatchEventView.vue?vue&type=script&lang=js"

import "./MatchEventView.vue?vue&type=style&index=0&id=43567ecf&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43567ecf"]])

export default __exports__